import { Stats, StatsFile, StatsFileDto, StatsFileProps } from "@domain";
import { AsyncInteractor } from "@kernel/frontend-react-app";
import { UniqueEntityId } from "@kernel/ddd";
import { StatsRepositoryService } from "../services";

export interface GetFileService {
  getFile(name: string): Promise<StatsFileDto>;
}

export interface GetStatsFileInteractorProps {
  name: string;
}

export class GetStatsFileInteractor extends AsyncInteractor<
  GetFileService,
  GetStatsFileInteractorProps,
  StatsFile
> {
  public async execute(props: GetStatsFileInteractorProps): Promise<StatsFile> {
    const dto = await this.service.getFile(props.name);
    return this.buildStatsFile(dto);
  }

  private buildStatsFile(dto: StatsFileDto): StatsFile {
    const props: StatsFileProps = {
      name: dto.name,
      checksum: dto.checksum,
      size: dto.size,
      fileTimes: dto.fileTimes,
      content: Stats.create(dto.content)
    };
    return StatsFile.create(props, new UniqueEntityId(dto.checksum));
  }

  public static create() {
    const service = new StatsRepositoryService();
    return new GetStatsFileInteractor(service);
  }
}
